var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","color":"background"},on:{"click":function($event){return _vm.sendEmail()}}},[_c('v-icon',{attrs:{"size":"27"}},[_vm._v("mdi-email-fast")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }